import { cmsCLient } from '@/services/axiosConfig'
import { GetRoamingPageRes } from './types'

export type GetRoaming = () => Promise<GetRoamingPageRes>

export const getRoaming: GetRoaming = async () => {
  try {
    const response = await cmsCLient.get('/roaming/list', { })
    return response.data
  } catch (e: any) {
    return e.message
  }
}
